// src/api.js

import {
  getAccessToken,
  getRefreshToken,
  setAccessToken,
  clearTokens,
} from './auth/tokenStore';

export function apiUrl(path) {
  if (path.startsWith('http://') || path.startsWith('https://')) return path;
  if (path.startsWith('/api/')) return path;
  if (path.startsWith('/')) return `/api${path}`;
  return `/api/${path}`;
}

export function mediaUrl(path) {
  if (!path) return '#';
  if (path.startsWith('http://') || path.startsWith('https://')) return path;
  if (path.startsWith('/media/')) return path;
  if (path.startsWith('media/')) return `/${path}`;
  return `/media/${path}`;
}

function parseErrorMessage(errData, status) {
  if (errData.detail) return String(errData.detail);
  if (typeof errData === 'object') {
    const parts = [];
    Object.entries(errData).forEach(([key, val]) => {
      const msg = Array.isArray(val) ? val.join(', ') : String(val);
      parts.push(`${key}: ${msg}`);
    });
    if (parts.length) return parts.join('; ');
  }
  return `Ошибка ${status}`;
}

async function refreshAccessToken() {
  const refresh = getRefreshToken();
  if (!refresh) return false;

  const response = await fetch(apiUrl('token/refresh/'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ refresh }),
  });

  if (!response.ok) return false;

  const data = await response.json();
  setAccessToken(data.access);
  return true;
}

function forceLogout() {
  clearTokens();
  window.dispatchEvent(new Event('auth:logout'));
}

export async function apiFetch(path, options = {}, retried = false) {
  const accessToken = getAccessToken();
  const headers = {
    ...options.headers,
  };

  // Формируем Authorization без дублирования "Bearer"
  if (accessToken) {
    const token = accessToken.startsWith('Bearer ') ? accessToken : `Bearer ${accessToken}`;
    headers['Authorization'] = token;
  }

  const isFormData = options.body instanceof FormData;

  // Если не FormData, устанавливаем Content-Type: application/json
  if (!isFormData) {
    headers['Content-Type'] = 'application/json';
  }

  // Тело: если не FormData и есть объект – сериализуем в JSON
  let body = options.body;
  if (!isFormData && body && typeof body === 'object') {
    body = JSON.stringify(body);
  }

  const response = await fetch(apiUrl(path), {
    ...options,
    headers,
    body,
  });

  if (response.status === 401 && !retried) {
    const refreshed = await refreshAccessToken();
    if (refreshed) {
      return apiFetch(path, options, true);
    }
    forceLogout();
    throw new Error('Сессия истекла. Пожалуйста, войдите заново.');
  }

  if (!response.ok) {
    let errorMessage = `Ошибка ${response.status}`;
    try {
      const errData = await response.json();
      errorMessage = parseErrorMessage(errData, response.status);
    } catch (_) {
      // ignore
    }
    throw new Error(errorMessage);
  }

  if (response.status === 204) return null;

  return response.json();
}